import React from 'react'

import { Typography, Box } from '@material-ui/core'

import getDateLabel from 'utils/getDateLabel'
import CopyButton from 'components/CopyButton'

const Info = ({
  eventTitle = '',
  eventStartDate,
  eventEndDate,
  pinCode,
  sessionTitle = '',
  sessionStartDate,
  sessionEndDate,
  timezone,
  is24hrFormat
}) => {
  const eventStartDateLabel = eventStartDate
    ? getDateLabel(eventStartDate, timezone, is24hrFormat)
    : ''
  const eventEndDateLabel = eventEndDate ? getDateLabel(eventEndDate, timezone, is24hrFormat) : ''
  const sessionStartDateLabel = sessionStartDate
    ? getDateLabel(sessionStartDate, timezone, is24hrFormat)
    : ''
  const sessionEndDateLabel = sessionEndDate
    ? getDateLabel(sessionEndDate, timezone, is24hrFormat)
    : ''
  return (
    <Box p={1} border={1}>
      <Box p={1} style={{ backgroundColor: '#ECECEC' }}>
        {eventTitle && (
          <Box display="flex">
            <Typography variant="h6" style={{ fontWeight: '700', width: '150px' }}>
              Event Title:
            </Typography>
            <Box sx={{ ml: '20px' }}>
              <Typography variant="h6" color="primary">
                {eventTitle}
              </Typography>
              <Typography
                variant="body1"
                style={{
                  fontSize: '13px',
                  fontStyle: 'italic',
                  marginTop: '-2px'
                }}
                color="textSecondary">
                {eventStartDateLabel} - {eventEndDateLabel}
              </Typography>
            </Box>
          </Box>
        )}
        {sessionTitle && sessionStartDateLabel && sessionEndDateLabel && (
          <Box display="flex">
            <Typography variant="h6" style={{ fontWeight: '700', width: '150px' }}>
              Sub Event Title:
            </Typography>
            <Box sx={{ ml: '20px' }}>
              <Typography variant="h6" color="primary">
                {sessionTitle}
              </Typography>
              <Typography
                variant="body1"
                style={{
                  fontSize: '13px',
                  fontStyle: 'italic',
                  marginTop: '-6px'
                }}
                color="textSecondary">
                {sessionStartDateLabel} - {sessionEndDateLabel}
              </Typography>
            </Box>
          </Box>
        )}
        {pinCode && (
          <Box sx={{ display: 'flex', mt: '10px' }}>
            <Typography variant="h6" style={{ fontWeight: '700', width: '150px' }}>
              PIN Code:
            </Typography>
            <Box sx={{ ml: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography variant="h6" color="primary">
                {pinCode}
              </Typography>
              <CopyButton value={pinCode} type="icon" tooltip="Copy Pin Code" />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Info
